import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Brand from '../../components/Common/Brand';
import CounterStyleThree from '../../components/Elements/Counter/CounterStyleThree';
import SectionTitle from '../../components/Common/SectionTitle';
import SingleService from '../../components/Service/SingleService';
import ProgressBar from '../../components/Elements/Progress/ProgressBar';
import ScrollToTop from '../../components/Common/ScrollTop';

// Import Components
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import SearchModal from '../../components/Layout/Header/SearchModal';
import SiteBreadcrumb from '../../components/Common/Breadcumb';

// Service Images
import serviceIcon1 from '../../assets/img/service/style7/1.png';
import serviceIcon2 from '../../assets/img/service/style7/2.png';
import serviceIcon3 from '../../assets/img/service/style7/3.png';

import aboutImg1 from '../../assets/img/about/1.jpg';
import whyChooseUsImg from '../../assets/img/choose/3.png';
import bannerbg from '../../assets/img/breadcrumbs/3.jpg';

const SoftwareDevelopment = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch('https://yautiktechnology.com/api/service/WebDevelopment')
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {
                setData(data);
                setLoading(false);
            })
            .catch((error) => {
                setError(error);
                setLoading(false);
            });
    }, []);

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error.message}</div>;

    return (
        <React.Fragment>
            <Header parentMenu="page" secondParentMenu="Web Development" activeMenu="/services" />

            <SiteBreadcrumb
                pageTitle="Web Development"
                titleClass="page-title"
                pageName="Services"
                breadcrumbsImg={bannerbg}
            />

            {/* About Section Start */}
            <div className="rs-about pt-120 pb-120 md-pt-80 md-pb-80">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 pr-40 md-pr-14 md-mb-50">
                            <SectionTitle
                                sectionClass="sec-title4"
                                subtitleClass="sub-text"
                                subtitle="Web Development"
                                titleClass="title"
                                title={data.heading}
                                effectClass="heading-line"
                            />
                            <SectionTitle
                                sectionClass="sec-title4"
                                descClass="desc desc-big"
                                description={data.description}
                            />
                            <div className="key-features">
                                <h4>{data.keyFeature}</h4>
                                <ul>
                                    <li><strong>{data.subHeading1}</strong>: {data.subHeadingDesc1}</li>
                                    <li><strong>{data.subHeading2}</strong>: {data.subHeadingDesc2}</li>
                                    <li><strong>{data.subHeading3}</strong>: {data.subHeadingDesc3}</li>
                                    <li><strong>{data.subHeading4}</strong>: {data.subHeadingDesc4}</li>
                                    <li><strong>{data.subHeading5}</strong>: {data.subHeadingDesc5}</li>
                                </ul>
                            </div>
                            <div className="btn-part mt-46">
                                <Link to="/contact">
                                    <a className="readon learn-more">Contact Us</a>
                                </Link>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="images">
                                <img src={aboutImg1} alt="Software Details" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Expert Section */}
            <div className="rs-services style5 pt-120 pb-120 md-pt-80">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 md-mb-30">
                            <SingleService
                                itemClass="services-item"
                                serviceImage={serviceIcon1}
                                Title={data.expHeading}
                                Text={data.expDesc}
                            />
                        </div>
                        <div className="col-lg-4 md-mb-30">
                            <SingleService
                                itemClass="services-item"
                                serviceImage={serviceIcon2}
                                Title={data.processHeading}
                                Text={data.processDesc}
                            />
                        </div>
                        <div className="col-lg-4">
                            <SingleService
                                itemClass="services-item"
                                serviceImage={serviceIcon3}
                                Title={data.ideaHeading}
                                Text={data.ideaDesc}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Why Choose Us Section */}
            <div className="rs-about gray-bg pt-120 pb-120 md-pt-80 md-pb-60">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 pr-46 md-pr-15 md-mb-50">
                            <div className="choose-img">
                                <img className="main" src={whyChooseUsImg} alt="" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <SectionTitle
                                sectionClass="sec-title mb-30"
                                subtitleClass="sub-text choose"
                                subtitle="Why Choose Us"
                                titleClass="title pb-20"
                                title={data.businessHeading}
                                descClass="desc"
                                description={data.businessDesc}
                            />
                            <div className="row">
                                <div className="col-lg-10">
                                    <div className="rs-skillbar style1 modify1">
                                        <div className="cl-skill-bar">
                                            <ProgressBar
                                                completed={92}
                                                height={7}
                                                boxbg={"#DFEDFE"}
                                                figurebg={"#03228f"}
                                                ProgressBox="skillbar"
                                                ProgressFigure="skillbar-bar"
                                                ProgressCount="skill-bar-percent"
                                                ProgressLabel="skillbar-title"
                                                label="Software Development"
                                                ProgressParent="main-div"
                                            />
                                            <ProgressBar
                                                completed={80}
                                                height={7}
                                                boxbg={"#DFEDFE"}
                                                figurebg={"#03228f"}
                                                ProgressBox="skillbar"
                                                ProgressFigure="skillbar-bar"
                                                ProgressCount="skill-bar-percent"
                                                ProgressLabel="skillbar-title"
                                                label="Cyber Security"
                                                ProgressParent="main-div"
                                            />
                                            <ProgressBar
                                                completed={95}
                                                height={7}
                                                boxbg={"#DFEDFE"}
                                                figurebg={"#03228f"}
                                                ProgressBox="skillbar"
                                                ProgressFigure="skillbar-bar"
                                                ProgressCount="skill-bar-percent"
                                                ProgressLabel="skillbar-title"
                                                label="Artificial Intelligence"
                                                ProgressParent="main-div"
                                            />
                                            <ProgressBar
                                                completed={78}
                                                height={7}
                                                boxbg={"#DFEDFE"}
                                                figurebg={"#03228f"}
                                                ProgressBox="skillbar"
                                                ProgressFigure="skillbar-bar"
                                                ProgressCount="skill-bar-percent"
                                                ProgressLabel="skillbar-title"
                                                label="Web Development"
                                                ProgressParent="main-div"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <CounterStyleThree />
            <Brand />
            <ScrollToTop />
            <Footer />
            <SearchModal />
        </React.Fragment>
    );
};

export default SoftwareDevelopment;
